// extracted by mini-css-extract-plugin
export default {"tag":"nXXbc","text":"jyJN4"};